import * as React from 'react';
import { Button, Cell, Grid, Loader } from '@teamsnap/teamsnap-ui';
import { messagesLink } from '../../utils/links';
import { useHistory } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { DateService, DateFormat } from 'frontend-toolkit';
import * as FormatRecipients from '../../core/formatRecipients';

import * as Messages from '../../core/gql/queries/show-messages';

interface Props {
  emailId: string;
  orgId: number;
}

const SentMessage: React.FC<Props> = ({ emailId, orgId }: Props) => {
  const history = useHistory();
  const { data } = useQuery(Messages.QUERY, {
    variables: { organizationId: orgId },
  });

  const renderRecipients = (recipients) => {
    const selectedRecipients = Object.entries(FormatRecipients.getSortedDivisionsGroupedByProgramsSeasons(recipients));

    type Program = [programSeasonName: string, divisions: []];

    return selectedRecipients.map(([programSeasonName, divisions]: Program) => (
      <Cell mods="u-xs-padTopSm" key={programSeasonName}>
        {programSeasonName}&nbsp;(<span className="u-colorGrey">{divisions.join(', ')}</span>)
      </Cell>
    ));
  };

  const renderEmail = () => {
    const targetEmail = data?.emails.find((email) => email.id === emailId);

    const { subject, body, senderName, sentAt, emailRecipients } = targetEmail;

    return (
      <Grid className="u-flexAlignItemsCenter">
        <Cell mods="u-xs-size1of1 u-padBottomSm">
          <h1>{subject}</h1>
        </Cell>

        <div className="page-content-body">
          <div className="page-content-body u-xs-size4of6">
            <Cell>
              <p>From: {senderName}</p>
              <p>{DateService.dateToString(new Date(sentAt), DateFormat.DATE_WITH_TIME)}</p>
            </Cell>

            <Cell mods="u-xs-padEndsMd">
              <div className="sent-messages-body" dangerouslySetInnerHTML={{ __html: body }} />
            </Cell>

            <Cell>
              <h4>Recipients</h4>
            </Cell>

            {renderRecipients(emailRecipients)}

            <Cell mods="u-xs-padTopXl u-xs-padBottomXl">
              <Button icon="left" mods="u-padSidesLg" onClick={() => history.push(messagesLink(orgId))}>
                Back
              </Button>
            </Cell>
          </div>
        </div>
      </Grid>
    );
  };

  if (data) {
    return renderEmail();
  }

  return <Loader type="spin" text="Loading email..." />;
};

export default SentMessage;
